import { Stack } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import { CenteredCircularProgress } from '../../../common/CenteredCircularProgress';

export const CardLoader = () => {
  return (
    <Stack
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 2,
        '&:after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: colors.white,
          opacity: 0.5,
        },
      }}
    >
      <CenteredCircularProgress />
    </Stack>
  );
};
